export const getFilenameFromPath = (
  path: string,
  fallback = "file",
): string => {
  return path.split("/").pop() || fallback;
};

export const normalizeS3Key = (path: string): string => {
  return path.startsWith("/") ? path.substring(1) : path;
};

export const getFileExtension = (path: string): string => {
  const ext = path.split(".").pop()?.trim().toUpperCase();
  return ext ? ext : "common.unknownFileType";
};
